import { RequestError } from "@myhealth-raccoon/services";

export function isRequestError(test: unknown): test is RequestError {
    return !!test && typeof test === 'object' && 'name' in test && test.name === 'Request Error';
}